var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgChartAccessLogo = function SvgChartAccessLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1409 237",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{font-size:180px;font-family:AcuminPro-Regular, Acumin Pro;letter-spacing:0.02em;}.cls-1,.cls-15{fill:none;}.cls-2{letter-spacing:0.02em;}.cls-3{letter-spacing:0.03em;}.cls-4{letter-spacing:0.05em;}.cls-5{letter-spacing:0.03em;}.cls-6{letter-spacing:0.03em;}.cls-7{letter-spacing:0.03em;}.cls-8{letter-spacing:0.02em;}.cls-9{isolation:isolate;}.cls-10{clip-path:url(#clip-path);}.cls-11{fill:url(#linear-gradient);}.cls-12{opacity:0.75;mix-blend-mode:darken;}.cls-13{fill:#363a3d;}.cls-14{fill:url(#linear-gradient-2);}.cls-15{stroke:#365ca9;stroke-miterlimit:10;stroke-width:14.82px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(260.15 175.24)"
  }, "C", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-2",
    x: 127.44,
    y: 0
  }, "h"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 232.74,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-4",
    x: 332.46,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 405.17,
    y: 0
  }, "t A"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-5",
    x: 640.43,
    y: 0
  }, "cc"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: 833.38,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-7",
    x: 933.46,
    y: 0
  }, "s"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-8",
    x: 1024.36,
    y: 0
  }, "s"))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 11.43,
    y1: 123.08,
    x2: 1705.43,
    y2: 123.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6aafe0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#67abdd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#558eca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#4777bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#3d67b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#375eab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#355ba9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 51.03,
    y1: 120.68,
    x2: 192.18,
    y2: 120.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#69addf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#365ca9"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 11.43,
    y: -46.42,
    width: 1694,
    height: 339
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M142.83,75.17h25.61c8.73,28.4,17.11,59.77,25.9,88.16H172a2.53,2.53,0,0,1-.12-.36l-.36-1.11-15.19-52.8-9.61,28.83A44.32,44.32,0,0,1,133,158.14c-9.13,7.53-20.88,11-34.72,10C60.4,165.51,42,126.76,60.36,96,69.82,80.23,80.91,75.15,99.2,75.17c7.15,0,17.27,2.75,23.78,5.58l-6.89,19.63a23.43,23.43,0,0,0-18.56-4.09,22.83,22.83,0,0,0-3.91,1c-9,3.19-14.76,12-15,22.85s5.65,20.38,15,24.16c9,3.66,19.92,1.55,26-5.67A34.08,34.08,0,0,0,125.36,128"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M140.68,74.1h25.6c8.74,28.39,17.11,59.76,25.9,88.15H169.8l-.12-.35-.36-1.12L154.14,108l-9.62,28.84a44.22,44.22,0,0,1-13.65,20.24c-9.12,7.53-20.88,11-34.71,10C58.24,164.43,39.83,125.68,58.21,95c9.46-15.8,20.54-20.89,38.84-20.86,7.14,0,17.26,2.75,23.77,5.57l-6.88,19.64a23.4,23.4,0,0,0-18.56-4.1,23.91,23.91,0,0,0-3.92,1c-9,3.19-14.75,12-15,22.85s5.65,20.38,15,24.16c9,3.66,19.92,1.56,26-5.67A34.26,34.26,0,0,0,123.2,127"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 121.56,
    cy: 120.5,
    r: 96.44
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChartAccessLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Chart-Access-Logo.59a786dd.svg";
export { ForwardRef as ReactComponent };